import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, opacity = 0, strokeWidth }) => (
  <g
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m68.536 95.686h23.847" />
    <path d="m68.536 53.102v42.584" />
    <path d="m106.2 53.213h33.243" />
    <path d="m122.84 53.215-0.0109 42.859" />
    <path d="m162.25 53.213h25.216" />
    <path d="m162.25 96.073h25.216" />
    <path d="m162.25 74.057h22.063" />
    <path d="m162.25 53.213v41.841" />
    <path
      d="m148.55 170.93a62.925 62.925 0 0 1-41.325-0.075 6 6 0 0 1-3.9-4.425l-4.35-22.125a6.15 6.15 0 0 0-3.675-4.425l-35.475-14.175a5.925 5.925 0 0 0-6.975 1.875 36 36 0 0 0 3 47.475 102.08 102.08 0 0 0 144.3 0 36 36 0 0 0 3-47.475 5.925 5.925 0 0 0-6.975-1.875l-35.475 14.175a6.15 6.15 0 0 0-3.675 4.35l-4.65 22.275a5.925 5.925 0 0 1-3.825 4.425z"
      fill={opacity ? color : 'none'}
      fillOpacity={opacity}
      strokeWidth={opacity === 1 ? 0 : strokeWidth}
    />
  </g>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const VoLTE = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

VoLTE.displayName = 'VoLTE';
